import StackAPI from '../../../lib/StackAPI'
import Storage from '../../../lib/Storage'
import { DeleteParams } from 'react-admin'

export const deleteOrgUser = async (params: DeleteParams) => {
  const { destroy } = StackAPI()
  const { getActiveRole } = Storage()

  const { organizationId: orgId } = getActiveRole()
  const ENDPOINT = `/api/organizations/${orgId}/relationships/org_users`

  const headers = {
    Accept: 'application/vnd.api+json',
    'Content-Type': 'application/vnd.api+json'
  }
  const payload = {
    data: [
      {
        id: params.id,
        type: 'org_users'
      }
    ]
  }

  const request = {
    path: ENDPOINT,
    params: payload,
    headers
  }

  return destroy(request)
    .then(({ data, status }) => (status === 204 ? data : []))
    .catch(() => ({ error: 'unknown error' }))
}
